module.exports = __webpack_public_path__ + "static/media/CatWork.55b06365.png";